<script>
import BlazeSlider from 'blaze-slider'
import 'blaze-slider/dist/blaze.css'
import { ArrowRightIcon, ArrowLeftIcon } from '@heroicons/vue/24/solid'
import TwCard from '@/components/generic/tw-card.vue'
import youtubeHelpersMixin from '@/mixins/youtubeHelpersMixin.js'
import TwTransitionContainer from '@/components/generic/tw-transition-container.vue'
import SlideShowSlide from '@/components/slide-show/public/slide-show-slide.vue'
import slideShowMixin from '@/mixins/slideShowMixin.js'


export default {
  name: 'FundraiserSlideShow',
  components: { SlideShowSlide, ArrowRightIcon, ArrowLeftIcon},
  mixins:[youtubeHelpersMixin, slideShowMixin],
  props: {
    fundraiser: {
      type: Object,
      required: true
    },
    showNavigation: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    slideshow() {
      return this.fundraiser.slideshow
    },
    slides() {
      const slides = []
      if(this.fundraiser.fundraiser_layout_configuration && this.fundraiser.fundraiser_layout_configuration.video_url) {
        slides.push({
          id: 0,
          type: 'youtube',
          thumbnail: `https://i.ytimg.com/vi/${this.getYoutubeIdFromUrl(this.fundraiser.fundraiser_layout_configuration.video_url)}/hqdefault.jpg`,
          url: this.fundraiser.fundraiser_layout_configuration.video_url
        })
      }
      if(this.fundraiser.slideshow) {
        this.fundraiser.slideshow.slides.forEach(slide => {
          if(slide.type === 'url') {
            console.log('processing slide type url:', slide.url)
            slides.push({
              ...slide,
              thumbnail: `https://i.ytimg.com/vi/${this.getYoutubeIdFromUrl(slide.url)}/hqdefault.jpg`,
              type: 'youtube'
            })
          }
          else {
            slides.push(slide)
          }
        })
      }
      return slides;
    },
    enableNavigationSliders() {
      return this.slides.length > 4
    },
  },
  mounted() {
    this.$nextTick( () => {
      if(this.slides.length === 0) return
      this.Slider = new BlazeSlider(document.querySelector('#slideshow-page-' + this.fundraiser.id), {
        all: {
          draggable: true,
          slidesToShow: (this.slides.length > 4)? 4 : this.slides.length,
          slidesToScroll: 1,
          slidesGap: '1 rem',
        },
      })
      this.Slider.onSlide((pageIndex, firstSlideIndex, lastSlideIndex) => {
        this.Slide = pageIndex + 1
      })
    })
  },
  methods: {
    scrollForward() {
      if(this.Slider) {
        this.Slider.next()
      }
    },
    scrollBackward() {
      if(this.Slider) {
        this.Slider.prev()
      }
    }
  }
}
</script>

<template>
  <div class="flex gap-4">
    <div v-if="enableNavigationSliders" class="col-span-1 flex justify-center items-center text-gray-500 hover:text-gray-300 cursor-pointer" @click="scrollBackward">
      <icon icon="chevron-left" size="1x" class="mt-8"/>
    </div>
    <div class="grid grid-cols-12">
      <div :class="[{'justify-center items-center col-span-12': enableNavigationSliders, 'col-span-12': !enableNavigationSliders}]" class="flex">
        <div v-if="slides && slides.length > 0" :id="'slideshow-page-' + fundraiser.id" class="blaze-slider">
          <div class="blaze-container mt-8">
            <div class="blaze-track-container">
              <div class="blaze-track h-20 sm:h-24 md:h-32">
                <slide-show-slide v-for="(slide, index) in slides" :key="'slideshow-slide-key-' + fundraiser.id + '-' + slide.id" readonly :slide="slide" class="flex justify-center h-full max-w-48" @clicked="slideShowItemClicked(index)" />
              </div>
            </div>
            <div v-if="showNavigation" class="flex justify-between mt-4">
              <button class="blaze-prev" aria-label="Go to previous slide">
                <ArrowLeftIcon class="size-5" />
              </button>
              <div class="pagination text-sm">
                {{ Slide }} / {{ slides.length }}
              </div>
              <button class="blaze-next" aria-label="Go to next slide">
                <ArrowRightIcon class="size-5" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="enableNavigationSliders" class="col-span-1 flex justify-center items-center text-gray-500 hover:text-gray-300 cursor-pointer">
      <icon icon="chevron-right" size="1x" @click="scrollForward" class="mt-8"/>
    </div>
  </div>
</template>

<style scoped>

</style>
